import React from 'react';
import ReactDOM from 'react-dom';
import { SwipeIcon } from '../resources/icons/Swipe';
import { MapModuleButton } from '../../mapmodule/MapModuleButton';

/**
 * @class Oskari.mapframework.bundle.mapmodule.plugin.LayerSelectionPlugin
 *
 * Provides mapmodule button for the swipe tool
 *
 * See http://www.oskari.org/trac/wiki/DocumentationBundleMapModulePluginLayerSelectionPlugin
 */
Oskari.clazz.define('Oskari.mapframework.bundle.layerswipe.plugin.LayerSwipePlugin',
/**
 * @method create called automatically on construction
 * @static
 */
function () {
  this._clazz = 'Oskari.mapframework.bundle.layerswipe.plugin.LayerSwipePlugin';
  this._defaultLocation = 'top left';
  this._index = 70;
  this._name = 'LayerSwipePlugin';
  this.handler = null;
  this.template = jQuery('<div class="mapplugin layerswipe"></div>');
}, {
  _startPluginImpl: function _startPluginImpl() {
    this.addToPluginContainer(this._createControlElement());
    this.refresh();
    return true;
  },
  _stopPluginImpl: function _stopPluginImpl() {
    var _this$getSandbox$find;
    // to sync toolbar button state on publisher close
    (_this$getSandbox$find = this.getSandbox().findRegisteredModuleInstance('LayerSwipe')) === null || _this$getSandbox$find === void 0 || _this$getSandbox$find.setToolActive(false);
    this.teardownUI();
  },
  setHandler: function setHandler(handler) {
    var _this = this;
    if (this.handler || !handler) {
      // already set or no handler
      return;
    }
    handler.addStateListener(function () {
      return _this.refresh();
    });
    this.handler = handler;
  },
  getHandler: function getHandler() {
    if (!this.handler) {
      var _this$getSandbox$find2;
      var handler = (_this$getSandbox$find2 = this.getSandbox().findRegisteredModuleInstance('LayerSwipe')) === null || _this$getSandbox$find2 === void 0 ? void 0 : _this$getSandbox$find2.getHandler();
      this.setHandler(handler);
    }
    return this.handler;
  },
  /**
   * @private @method  _createControlElement
   * Creates the whole ui from scratch and writes the plugin in to the UI.
   * Tries to find the plugins placeholder with 'div.mapplugins.left' selector.
   * If it exists, checks if there are other bundles and writes itself as the first one.
   * If the placeholder doesn't exist the plugin is written to the mapmodules div element.
   */
  _createControlElement: function _createControlElement() {
    return this.template.clone();
  },
  refresh: function refresh() {
    var el = this.getElement();
    var handler = this.getHandler();
    if (!el || !handler) {
      return;
    }
    var _handler$getState = handler.getState(),
      active = _handler$getState.active,
      noUI = _handler$getState.noUI;
    var controller = handler.getController();
    ReactDOM.render(/*#__PURE__*/React.createElement(MapModuleButton, {
      className: "t_layerswipe",
      highlight: "stroke",
      icon: /*#__PURE__*/React.createElement(SwipeIcon, null),
      visible: !noUI,
      title: Oskari.getMsg('LayerSwipe', 'toolLayerSwipe'),
      onClick: function onClick() {
        return controller.toggleTool();
      },
      iconActive: active,
      position: this.getLocation(),
      iconSize: "20px"
    }), el[0]);
  }
}, {
  extend: ['Oskari.mapping.mapmodule.plugin.BasicMapModulePlugin'],
  /**
   * @static @property {string[]} protocol array of superclasses
   */
  protocol: ['Oskari.mapframework.module.Module', 'Oskari.mapframework.ui.module.common.mapmodule.Plugin']
});